/**
 * Quick chip key lists per module (labels/prompts in aiAgentPages.json).
 */

import {
  buildDefaultQuickChips,
  buildModuleQuickChips,
} from './agentModuleI18n';
import { MODULE_QUICK_CHIP_KEYS } from './agentModuleQuickChips.keys';

export { MODULE_QUICK_CHIP_KEYS } from './agentModuleQuickChips.keys';

export function getModuleQuickChips(moduleId) {
  const keys = MODULE_QUICK_CHIP_KEYS[moduleId];
  if (keys?.length) {
    return buildModuleQuickChips(moduleId, keys);
  }

  return buildDefaultQuickChips(moduleId);
}
